// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner___5P_v"};